export default __webpack_public_path__ + "static/media/icon-check-green-type.129e721d.svg";